<script lang="ts">
  import DropdownInput from '$lib/components/control/dropdown/Dropdown.svelte';
  import type { Dropdown } from './types';

  export let customClass = '';
  export let dropdowns: Dropdown[] | null = null;
  export let selectedValues = {};
  export let handleSelect: ((...args: any[]) => Promise<void>) | undefined = undefined;
</script>

<div class={customClass}>
  {#if dropdowns?.length}
    {#each dropdowns as dropdown}
      {#if dropdown.options.length}
        <label
          class="grow basis-0 flex-shrink-0 w-full text-gray-700 text-normal flex flex-col"
          for={dropdown.id}
          >{dropdown.label}
          <DropdownInput
            theme="pink"
            customClass="mt-1"
            dropdownDetails={dropdown}
            selectedValues={selectedValues[dropdown.id]}
            {handleSelect}
          />
        </label>
      {/if}
    {/each}
  {/if}
</div>
